import {
    applyMiddleware,
    compose,
    createStore as createReduxStore,
} from 'redux';
import { Action } from 'redux-actions';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import { setStore } from 'store/store';
import { flushUsedNames } from 'utils/StateHelper';

import rootReducer, { GlobalState } from 'reactApp/core/rootReducer';

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
    }
}

const middlewares = [thunk];

function configureStoreProd(initialStore = {}) {
    return createReduxStore<GlobalState, Action<any>, ThunkMiddleware, any>(
        // @ts-ignore
        rootReducer,
        initialStore,
        // @ts-ignore
        compose(applyMiddleware(...middlewares)),
    );
}

function configureStoreDev(initialStore = {}) {
    const composeEnhancers =
        (window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
    const store = createReduxStore<
        GlobalState,
        Action<any>,
        ThunkMiddleware,
        any
    >(
        // @ts-ignore
        rootReducer,
        initialStore,
        composeEnhancers(applyMiddleware(...middlewares)),
    );

    if (module.hot) {
        module.hot.accept('reactApp/core/rootReducer', () => {
            flushUsedNames();
            const imported = require('reactApp/core/rootReducer');
            store.replaceReducer(imported);
        });
    }

    return store;
}

const createStore =
    process.env.NODE_ENV === 'production'
        ? configureStoreProd
        : configureStoreDev;

async function loadInitialState() {
    if (process.env.NODE_ENV !== 'development') {
        return {};
    }
    /**
     * You can place initial state in /static/state/json
     * in development build this state will be loaded and initialized
     */
    try {
        const result = await fetch(
            `https://local.mcs.devmail.ru:8000/static/state.json?_=${Math.random()}`,
            {
                mode: 'no-cors',
            },
        );
        const data = await result.json();

        return data || {};
    } catch (error) {
        return {};
    }
}

export const StoreCreatingPromise = (async function() {
    const initialState = await loadInitialState();

    const store = createStore(initialState);
    setStore(store);
})();
